import baseRoutes from './base/routes'

function requireAll(requireContext) {
  return requireContext.keys()
    .filter((name) => {
      // base HAS to be the last set of routes, so we load them manually
      return name.indexOf('base') === -1
        // ignore non-domain folders
        && name.indexOf('shared') === -1
        && name.indexOf('config') === -1
        && name.indexOf('frontend') === -1
    })
    .map((key) => {
      const routes = requireContext(key)
      return routes
    })
}

const routes = requireAll(require.context('./', true, /^\.\/[^/]+\/routes.js$/))

export default [
  ...routes,
  /* Other routes should come before base routes */
  baseRoutes,
]



// WEBPACK FOOTER //
// ./src/routes.js